import { render, staticRenderFns } from "./page4.vue?vue&type=template&id=32f456a4&scoped=true"
var script = {}
import style0 from "./page4.vue?vue&type=style&index=0&id=32f456a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f456a4",
  null
  
)

export default component.exports